import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData } from '../../generated';
import type { CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostError } from '../../generated';
import type { CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostResponse } from '../../generated';
import { createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost } from '../../generated';

// planned_retailer: drop once pnpm generate carries it.
export type CreateUnlistedPdpMutationVariables = CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData['path'] &
  CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostData['body'] & { planned_retailer?: string | null };

export type CreateUnlistedPdpMutation = CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostResponse;

export const useCreateUnlistedPdpMutation = <
  TError = CreateUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateUnlistedPdpMutation, TError, CreateUnlistedPdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateUnlistedPdpMutation, TError, CreateUnlistedPdpMutationVariables, TContext>({
    mutationKey: ['CreateUnlistedPdp'],
    mutationFn: async ({ workspace_id, ...body }: CreateUnlistedPdpMutationVariables) => {
      const { data } = await createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost({
        path: { workspace_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateUnlistedPdpMutation.fetcher = (
  { workspace_id, ...body }: CreateUnlistedPdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createUnlistedPdpV1WorkspacesWorkspaceIdPdpsUnlistedPost({
      path: { workspace_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
